
import axios from "axios";
import {SERVER_ADDRESS, SERVER_PORT} from "./constants";


export const getStyles = async () => {
        
    return axios.get(SERVER_ADDRESS+":"+SERVER_PORT+"/api/styles");
};
